<template lang="pug">
#modal-ambiente(style='z-index: 4000')
    el-dialog(
        width='350px',
        top='5vh',
        :visible='show',
        @close='$emit("close")'
    )
        .modal-linguagem-header
            i.mdi.mdi-web
            p {{ $t('mensagens.comuns.selecionePaisDesejado') }}
        .modal-linguagem-content
            .linguagem(
                v-if='usuario.isBrasil',
                @click='alterarAmbiente(ambientes.BRASIL)'
            )
                .sl-flag.flag-pt-BR
                | Brasil
            .linguagem(
                v-if='usuario.isParaguay',
                @click='alterarAmbiente(ambientes.PARAGUAY)'
            )
                .sl-flag.flag-paraguai
                | Paraguai
            .linguagem(
                v-if='usuario.isArgentina',
                @click='alterarAmbiente(ambientes.ARGENTINA)'
            )
                .sl-flag.flag-argentina
                | Argentina
</template>

<script>
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'ModalAmbiente',
    props: {
        show: {
            type: Boolean
        },
        usuario: {
            type: Object
        }
    },
    data() {
        return {
            ambientes: AmbientesEmpresas
        };
    },
    methods: {
        alterarAmbiente(novoAmbiente) {
            this.$emit('alterarAmbiente', novoAmbiente);
        }
    }
};
</script>
<style lang="scss">
#modal-ambiente {
    .el-dialog__header {
        padding: 0px;
        background: transparent !important;
        padding-bottom: 5px !important;
    }
    .modal-linguagem-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        i {
            font-size: 34px;
            color: var(--primary);
        }

        p {
            margin: 0;
            font-size: 18px;
            color: #2a2a2a;
        }
    }
    .modal-linguagem-content {
        border: 1px solid #e8e6e6;
        border-radius: 4px;
        padding: 9px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .linguagem {
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        gap: 10px;
        font-size: 16px;
        color: #2a2a2a;
        font-weight: 400;
        cursor: pointer;
    }
    .linguagem:hover {
        background: #f5f5f5;
    }
}
</style>
